import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-privacidad',
    templateUrl: './privacidad.component.html',
    styleUrls: ['./privacidad.component.css'],
    standalone: false
})
export class PrivacidadComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private seo: SeoService
  ) { 
    if (isPlatformBrowser(this.platformId)) window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    this.seo.update({
      title: 'Terminos y condiciones | Clave Winds',
      description: 'Terminos, condiciones de uso y aviso de privacidad de Clave Winds.',
      canonical: this.seo.absoluteUrl('/privacidad')
    });
  }

}
